module.exports = __webpack_public_path__ + "files/c10e91f896b0db454fc62bcda7e4c0cf.png";